export default "__VITE_ASSET__umASzIOQ__"